var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFileIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file",
    d: "M7.375,3H14.25L17,5.8v9.8A1.388,1.388,0,0,1,15.625,17H7.375A1.388,1.388,0,0,1,6,15.6V4.4A1.388,1.388,0,0,1,7.375,3Zm6.306,1.4H7.375V15.6h8.25V6.38H13.681Z",
    transform: "translate(-6 -3)",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFileIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/file_icon.025b3bccd542059b42f09954b1754d5d.svg";